
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import { Condition } from "@/utils/condition/condition";
import Vue from "vue";
import AppFieldConditionEdit from "../models/ConditionEdit.vue";
import {getSaleInSaleLayoutPropSelectGroup} from "@/utils/prop-select/sale-in-sale-layout-prop-group";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import AppPropSelectAutocomplete from "@/components/prop-select/PropSelectAutocomplete.vue";
import { getSaleMapPropSelectGroup } from "@/utils/prop-select/sale-map-prop-group";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import { TextStyledProperty } from "@/utils/documents/text-styled-property";
import { FieldWithSeperateStyles } from "@/utils/documents/field-with-seperate-styles";

export default Vue.extend({
	data() {
		return {
			lang: "",
			hiddenKeys: [] as string[],
			toEditStyleProp: "" as "" | "pre" | "prop" | "post"
		};
	},
	props: {
		value: {
			type: Object as () => FieldWithSeperateStyles,
			required: true
		},
		selectedLang: String,
		title: {
			type: String,
			default():string{
				return this.$ct("edit-prop").toString();
			}
		}
	},
	computed: {
		props(): PropSelectGroup {
			return getSaleMapPropSelectGroup();
		},
		conditionProps():PropSelectGroup{
			return getSaleInSaleLayoutPropSelectGroup();
		},
		toEditStyle():TextStyledProperty | null {
			if (this.toEditStyleProp == "pre") {
				return this.value.Style;
			}
			if (this.toEditStyleProp == "prop") {
				return this.value.PropStyle;
			}
			if (this.toEditStyleProp == "post") {
				return this.value.AfterTextStyle;
			}
			return null;
		}
	},
	watch: {
		selectedLang: {
			immediate: true,
			handler(lang: string) {
				this.lang = lang;
			}
		},
		lang(lang: string) {
			if (lang == this.selectedLang) return;
			this.$emit("update:selectedLang", lang);
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async addCondition(){
			let condition = new Condition();
			this.hiddenKeys.push(condition.key);
			this.value.Conditions.push(condition);
			await this.$nextTick();
			this.hiddenKeys.pop();
		},
		removeCondition(i:number){
			this.value.Conditions.splice(i,1);
		},
		shouldShowKey(key:string):boolean{
			return this.hiddenKeys.indexOf(key) == -1;
		},
		onStyle(style:TextStyledProperty){
			if (this.toEditStyleProp == "pre") {
				this.value.Style = style;
			}else if (this.toEditStyleProp == "prop") {
				this.value.PropStyle = style;
			}else if (this.toEditStyleProp == "post"){
				this.value.AfterTextStyle = style;
			}
		}
	},
	components: {
		AppCustomLangSelect,
		AppFieldConditionEdit,
		AppPropSelectAutocomplete,
		AppStyleEditor
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
